// LearnCore Frontend - 奖励页面（儿童友好版本）

import React, { useState } from 'react';
import RewardList from '../components/RewardList';
import type { RewardType } from '../types/tasks-rewards';

const RewardsPage: React.FC = () => {
  const [refreshKey, setRefreshKey] = useState(0);
  const [activeCategory, setActiveCategory] = useState<'all' | 'digital' | 'privilege' | 'custom'>('all');

  const handleRedeem = () => {
    setRefreshKey(prev => prev + 1);
  };

  const getFilters = () => {
    const baseFilters = {
      available_only: true,
      sort_by: 'dkp_cost_asc' as const
    };

    switch (activeCategory) {
      case 'digital':
        return { ...baseFilters, type: ['digital' as RewardType] };
      case 'privilege':
        return { ...baseFilters, type: ['privilege' as RewardType] };
      case 'custom':
        return { ...baseFilters, type: ['custom' as RewardType] };
      default:
        return baseFilters;
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-purple-50 to-pink-50 dark:from-gray-900 dark:via-purple-900/20 dark:to-blue-900/20">
      <div className="max-w-4xl mx-auto px-4 py-8">
        {/* 页面标题 - 儿童友好风格 */}
        <div className="text-center mb-10">
          <div className="inline-flex items-center justify-center w-20 h-20 bg-gradient-to-r from-yellow-400 to-orange-400 rounded-full mb-4 animate-bounce">
            <span className="text-4xl">🎁</span>
          </div>
          <h1 className="text-4xl font-bold text-gray-800 dark:text-white mb-3">
            🌟 奖励商店 🌟
          </h1>
          <p className="text-xl text-gray-600 dark:text-gray-300">
            用你的金币兑换精彩奖励！
          </p>
        </div>

        {/* 快速分类选择 - 儿童友好的大按钮 */}
        <div className="flex justify-center gap-4 mb-10 flex-wrap">
          {[
            { key: 'all', label: '🎯 全部奖励', color: 'from-blue-400 to-blue-500' },
            { key: 'digital', label: '🎮 数字奖励', color: 'from-purple-400 to-purple-500' },
            { key: 'privilege', label: '👑 特权奖励', color: 'from-pink-400 to-pink-500' },
            { key: 'custom', label: '🎨 自定义奖励', color: 'from-green-400 to-green-500' }
          ].map((category) => (
            <button
              key={category.key}
              onClick={() => setActiveCategory(category.key as any)}
              className={`px-8 py-4 bg-gradient-to-r ${category.color} text-white text-lg font-bold rounded-2xl transition-all duration-300 transform hover:scale-105 active:scale-95 shadow-lg hover:shadow-xl ${
                activeCategory === category.key
                  ? 'ring-4 ring-white ring-opacity-60 animate-pulse'
                  : ''
              }`}
            >
              {category.label}
            </button>
          ))}
        </div>

        {/* 奖励列表 */}
        <RewardList
          key={refreshKey}
          filters={getFilters()}
          onRedeem={handleRedeem}
          showUserDKP={true}
          className="mb-8"
        />

        {/* 底部鼓励信息 */}
        <div className="text-center mt-12 p-8 bg-white dark:bg-gray-800 rounded-3xl shadow-xl border border-gray-200 dark:border-gray-700">
          <div className="text-6xl mb-4">🚀</div>
          <h3 className="text-2xl font-bold text-gray-800 dark:text-white mb-3">
            继续加油！
          </h3>
          <p className="text-lg text-gray-600 dark:text-gray-300 mb-6">
            完成更多学习任务，赚取金币，解锁更多精彩奖励！
          </p>
          <div className="flex justify-center gap-8">
            <div className="text-center">
              <div className="text-3xl mb-2">📚</div>
              <div className="text-sm text-gray-600 dark:text-gray-400">认真学习</div>
            </div>
            <div className="text-center">
              <div className="text-3xl mb-2">💰</div>
              <div className="text-sm text-gray-600 dark:text-gray-400">获得金币</div>
            </div>
            <div className="text-center">
              <div className="text-3xl mb-2">🎁</div>
              <div className="text-sm text-gray-600 dark:text-gray-400">兑换奖励</div>
            </div>
          </div>
        </div>
      </div>

      {/* 背景装饰 */}
      <div className="fixed top-10 left-10 text-6xl opacity-20 animate-pulse">🌟</div>
      <div className="fixed top-20 right-20 text-4xl opacity-20 animate-bounce" style={{ animationDelay: '1s' }}>🎈</div>
      <div className="fixed bottom-20 left-20 text-5xl opacity-20 animate-pulse" style={{ animationDelay: '2s' }}>🎯</div>
      <div className="fixed bottom-10 right-10 text-6xl opacity-20 animate-bounce" style={{ animationDelay: '3s' }}>🏆</div>
    </div>
  );
};

export default RewardsPage;